import angular from 'angular';
import questionModalComponent from './questionModal.component';

let questionModalModule = angular.module('questionModal', [
])

.component('questionModal', questionModalComponent)

.name;

export default questionModalModule;



// WEBPACK FOOTER //
// ./client/app/components/questionModal/questionModal.js